module.exports = __webpack_public_path__ + "static/media/2022__K8A0144.98d80d7e.jpg";